import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { billingApi } from '../services/api';
import { useMembership } from '../hooks/useMembership';

const formatDate = (iso: string) => new Date(iso).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });

/** Profile card: the member's plan(s) and a way into Stripe's billing portal. */
const MembershipCard: React.FC = () => {
  const { membershipsEnabled, membership } = useMembership();
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!membershipsEnabled || !membership || membership.isStaff) return null;

  const openPortal = async () => {
    setOpening(true);
    setError(null);
    try {
      const { url } = await billingApi.portal();
      window.location.href = url;
    } catch {
      setError('Couldn’t open billing. Please try again.');
      setOpening(false);
    }
  };

  return (
    <div className="form-container auth-form-container membership-card">
      <h2>Membership</h2>
      {membership.subscriptions.length === 0 ? (
        <>
          <p className="auth-subtitle">You’re on the free plan.</p>
          <Link to="/join" className="btn btn-primary">See membership plans</Link>
        </>
      ) : (
        <>
          <ul className="membership-list">
            {membership.subscriptions.map((s) => (
              <li key={s.id}>
                <strong>{s.plan.name}</strong>
                <span className="auth-subtitle">
                  {s.source === 'manual'
                    ? s.expiresAt ? ` · included until ${formatDate(s.expiresAt)}` : ' · included by your studio'
                    : s.status === 'past_due'
                      ? ' · payment failed, please update your card'
                      : s.currentPeriodEnd
                        ? ` · ${s.cancelAtPeriodEnd ? 'ends' : 'renews'} ${formatDate(s.currentPeriodEnd)}`
                        : ''}
                </span>
              </li>
            ))}
          </ul>
          {membership.canManageBilling && (
            <button type="button" className="btn btn-secondary" onClick={openPortal} disabled={opening}>
              {opening ? 'Opening…' : 'Manage membership'}
            </button>
          )}
        </>
      )}
      {error && <p className="auth-error">{error}</p>}
    </div>
  );
};

export default MembershipCard;
